import { render, staticRenderFns } from "./GrainSpecificationsDetail.vue?vue&type=template&id=e89a5564&scoped=true"
import script from "./GrainSpecificationsDetail.vue?vue&type=script&lang=js"
export * from "./GrainSpecificationsDetail.vue?vue&type=script&lang=js"
import style0 from "./GrainSpecificationsDetail.vue?vue&type=style&index=0&id=e89a5564&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e89a5564",
  null
  
)

export default component.exports